import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useAgencyAccounts = () => {
  const customerId = useCustomerId()

  return useQuery({
    queryKey: ['agencies', customerId, 'accounts'],
    queryFn: () => get(`/customers/${customerId}/master/accounts`),
  })
}
